import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { Button } from '@calendly/ui/components/button';
import { BodyText, TitleText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useNewEmptyStates } from 'features/empty_state';
import { AdditionalResourcesEmailSvg, MeetingFollowUpSvg, ReconfirmationEmailSvg, ReconfirmationTextSvg, ReminderEmailSvg, ReminderTextSvg, SurveyEmailSvg, ThankYouEmailSvg, NoShowEmailSvg, IconCancellationTextSvg, ConfirmationTextSvg, FollowUpTextSvg, ThirdPartyEmailSvg } from './images';
const templateIconMap = {
  reminder_email: ReminderEmailSvg,
  thank_you_email: ThankYouEmailSvg,
  no_show_email: NoShowEmailSvg,
  additional_resources_email: AdditionalResourcesEmailSvg,
  meeting_follow_up: MeetingFollowUpSvg,
  survey_email: SurveyEmailSvg,
  reminder_text: ReminderTextSvg,
  reconfirmation_email: ReconfirmationEmailSvg,
  reconfirmation_text: ReconfirmationTextSvg,
  cancellation_text: IconCancellationTextSvg,
  confirmation_text: ConfirmationTextSvg,
  follow_up_text: FollowUpTextSvg,
  send_to_someone_else_email: ThirdPartyEmailSvg
};
const iconBlockCss = "igs9axa";
const IconBlock = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(iconBlockCss, props.className)} />;
});
const tileIconCss = "t2v9sue";
const TileIcon = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'img';
  return <Component ref={ref} {...restProps} className={classNames(tileIconCss, props.className)} />;
});
const buttonCardIsDisabledCss = "bqp5hqy";
const buttonCardCss = "bmd1uim";
const ButtonCard = forwardRef((props, ref) => {
  const isDisabled = props.disabled;
  return <BareButton ref={ref} {...props} className={classNames(buttonCardCss, {
    [buttonCardIsDisabledCss]: isDisabled
  }, props.className)} />;
});
const tileCardTextBlockCss = "t1k95n0y";
const TileCardTextBlock = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(tileCardTextBlockCss, props.className)} />;
});
const tileCardControlsWrapperCss = "t9j3sci";
const TileCardControlsWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(tileCardControlsWrapperCss, props.className)} />;
});
const TileCardControls = () => {
  const isNewEmptyStateEnabled = useNewEmptyStates();
  let buttonText = I18n.t('publisher.workflows.workflow_templates.add_workflow');
  if (isNewEmptyStateEnabled) {
    buttonText = I18n.t('publisher.workflows.workflow_templates.add_workflow_alternate');
  }
  return <TileCardControlsWrapper>
      <Button as="div" size="small">
        {buttonText}
      </Button>
    </TileCardControlsWrapper>;
};
const warningMessageWrapperCss = "wb280xe";
const WarningMessageWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(warningMessageWrapperCss, props.className)} />;
});
const WarningMessage = () => <WarningMessageWrapper>
    <span>{I18n.t('publisher.enforcement.sms_deactivated')}</span>
  </WarningMessageWrapper>;
export const TileButton = ({
  icon,
  name,
  description,
  smsBlocked = false,
  ...restProps
}) => <ButtonCard {...restProps}>
    <IconBlock>
      <TileIcon src={templateIconMap[icon]} alt="" />
    </IconBlock>
    <TileCardTextBlock>
      <TitleText level={2} size="medium" as="div">{name}</TitleText>
      <BodyText color="muted">{description}</BodyText>
    </TileCardTextBlock>
    {smsBlocked ? <WarningMessage /> : <TileCardControls />}
  </ButtonCard>;

require("./tile_button.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./tile_button.js");